import { render, staticRenderFns } from "./InfoCostos.vue?vue&type=template&id=3ac0bc68&scoped=true&"
import script from "./InfoCostos.vue?vue&type=script&lang=ts&"
export * from "./InfoCostos.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCostos.vue?vue&type=style&index=0&id=3ac0bc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0bc68",
  null
  
)

export default component.exports